import React from "react";
import {
  FooterContainer,
  FooterContainerFirstBlock,
  AppLinks,
  GooglePlay,
  ClaroPay,
  AppStore,
  FooterContainerLastBlock,
  FooterList,
  PolicyList,
  FooterContainerPolicyBlock,
  ListItem,
  DivisionFooter,
  DivisionFooterBar,
} from "./NewFooter.styles";

import iconeTelefone from "../../../images/icone-telefone.svg";
import iconeSms from "../../../images/icone-sms.svg";
import iconeMinhaClaro from "../../../images/icone-minhaClaro.svg";
import iconeGooglePlay from "../../../images/icone-googlePlay.svg";
import iconeAppStore from "../../../images/icone-appStore.svg";
import iconeWpp from "../../../images/whatsapp-logo-png.png";
import policiesFooter from "../../../staticFiles/policiesFooter.json";
import iconeClaroPay from "../../../images/icone-claropay.svg";

const NewFooter = () => (
  <>
    <FooterContainer>
      <FooterContainerFirstBlock>
        <p>app claro recarga</p>
        <AppLinks>
          <a
            href="https://play.google.com/store/apps/details?id=br.com.m4u.recarga.claro"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GooglePlay src={iconeGooglePlay} alt="" />
          </a>
          <a
            href="https://itunes.apple.com/br/app/claro-recarga/id1323057485?mt=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AppStore src={iconeAppStore} alt="" />
          </a>
        </AppLinks>
      </FooterContainerFirstBlock>

      <FooterContainerLastBlock>
        <p>Recarregue Também</p>
        <FooterList>
          <ListItem>
            <img src={iconeWpp} alt="" />
            <span>
              WhatsApp
              <br />
              (11) 99991-0621
            </span>
          </ListItem>

          <ListItem>
            <img src={iconeMinhaClaro} alt="" />
            <span>Minha Claro</span>
          </ListItem>

          <ListItem>
            <img src={iconeTelefone} alt="" />
            <span>Telefone *555</span>
          </ListItem>

          <ListItem>
            <img src={iconeSms} alt="" />
            <span>SMS *555</span>
          </ListItem>

          <ListItem>
            <img src={iconeSms} alt="" />
            <span>USSD *555#</span>
          </ListItem>

          <ClaroPay src={iconeClaroPay} alt="Logo do Claro Pay" />
        </FooterList>
      </FooterContainerLastBlock>
    </FooterContainer>

    <DivisionFooter>
      <DivisionFooterBar />
    </DivisionFooter>

    <FooterContainerPolicyBlock>
      <PolicyList>
        <a href={policiesFooter.regulamento.link} target="_blank" rel="noopener noreferrer">
          Regulamento Completo
        </a>
        <a href={policiesFooter.politicaPrivacidade.link} target="_blank" rel="noopener noreferrer">
          Política de Privacidade
        </a>
        <a href={policiesFooter.portalPrivacidade.link} target="_blank" rel="noopener noreferrer">
          Portal de Privacidade
        </a>
      </PolicyList>
    </FooterContainerPolicyBlock>
  </>
);

export default NewFooter;
